import React, { useEffect } from "react";

export default function LangPage({ lang }) {
  useEffect(() => {
    localStorage.setItem("LANG", lang);
    window.location = "/";
  }, []);
  return <div></div>;
}
